import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { Tooltip } from '../../Tooltip/Tooltip.jsx';

const _SortableColumn = ({ text, classNames, tooltipText, name }) => (
  <div className={`cart-table__header-cell ${classNames} ${name}`}>
    <span>{text}</span>
    {tooltipText && <Tooltip>{tooltipText}</Tooltip>}
  </div>
);

_SortableColumn.propTypes = {
  classNames: propTypes.string,
  tooltipText: propTypes.oneOfType([propTypes.string, propTypes.bool]),
  text: propTypes.string.isRequired,
  name: propTypes.string.isRequired
};

export const SortableColumn = inject('uiStore')(observer(_SortableColumn));
